import { loadTossPayments } from '@tosspayments/payment-sdk';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Box } from '@mui/material';

const SERVER = process.env.REACT_APP_SERVER;

function Payments() {
    const navigate = useNavigate();
    const location = useLocation();
    const { amount, orderName, customerName, customerEmail, applicationId, method } =
        location.state || '';
    useEffect(() => {
        const orderInfo = {
            amount: amount,
            orderName: orderName,
            customerName: customerName,
            customerEmail: customerEmail,
            applicationId: applicationId,
            successUrl: `${window.location.origin}/payments/success/${applicationId}`,
            failUrl: `${window.location.origin}/payments/fail/${applicationId}`,
        };

        //토스 결제창 띄우기
        async function getPay() {
            const { data } = await axios.post(`${SERVER}/api/payments`, orderInfo);
            const tossPayments = await loadTossPayments(data.clientKey);
            tossPayments.requestPayment(method, data)
            .catch((err) => {
                console.log(err);
                if (err.code && err.code == 'USER_CANCEL') {
                    alert('결제를 취소하셨습니다. 다시 시도해주세요.');
                }
                if(customerEmail){
                    navigate('/lecture', { state: { email: customerEmail } });
                }else{
                    navigate('/lecture');
                }
            });
        }

        getPay();
    }, [amount, orderName, customerName, customerEmail, applicationId]);

    return <Box sx={{ minHeight: '70vh' }}></Box>;
}

export default Payments;
